import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["filterType"];
import styled from 'styled-components';
import { Set as ImmutableSet } from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import LanguageNames from 'ui-addon-i18n/constants/LanguageNames';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { useSearchParam, useSearchParamInput, useLocationWithoutParams
// @ts-expect-error Could not find a declaration file for module
} from '../../hooks/searchParamHooks';
import { device } from '../../constants/StyledComponentConstants';
import UsageTracker from '../../utils/UsageTracker';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { useCanFilterContentTypeByPlaylist, useFilterOptions } from '../../features/filters/filtersHooks';
import { FilterItems } from './FilterItems';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StyledTagsContainer = styled.div.withConfig({
  displayName: "RouterDropdownFilter__StyledTagsContainer"
})(["line-height:2.4;margin:-10px 0 0 -4px;padding-bottom:16px;display:flex;flex-wrap:wrap;@media screen and ", "{flex-wrap:nowrap;overflow-x:scroll;margin:0;padding-left:8px;padding-top:5px;padding-bottom:6px;&:empty{padding:0;}a:last-child{padding-right:12px;}&::-webkit-scrollbar{width:0;background:transparent;height:0;}}"], device.mobile);
const onClearFiltersClick = () => {
  UsageTracker.track('interaction', {
    action: 'clear-filters-click'
  });
};
export const ClearFiltersLink = ({
  filtersToClear
}) => {
  const [isClearable, destination] = useLocationWithoutParams(filtersToClear);
  return isClearable ? /*#__PURE__*/_jsx(RouterLink, {
    "data-test-id": "clear-top-filters",
    insetBlockStart: "50" /* TODO double check if this is working as intended */,
    onClick: onClearFiltersClick,
    paddingInlineStart: "300" /* TODO double check if this is working as intended */,
    position: "relative",
    to: destination,
    children: /*#__PURE__*/_jsx("span", {
      style: {
        whiteSpace: 'nowrap'
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.filters.clearFilters"
      })
    })
  }) : null;
};
export const RouterChecklistFilter = ({
  defaultItem,
  filterType,
  replace,
  hideReset
}) => {
  let options = useFilterOptions(filterType);
  const canFilterContentTypeByPlaylist = useCanFilterContentTypeByPlaylist();
  const [paramValue, changeHandler] = useSearchParamInput(filterType, replace);
  const [__, changeHandlerReplace] = useSearchParamInput(filterType, true);
  let valuesSet = ImmutableSet(paramValue);
  if (!valuesSet.size && defaultItem) {
    valuesSet = valuesSet.add(defaultItem);
  }
  if (!canFilterContentTypeByPlaylist) {
    options = options.filter(item => item !== 'LEARNING_PATH');
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!hideReset && /*#__PURE__*/_jsx(Checkbox, {
      checked: valuesSet.isEmpty(),
      "data-test-id": `${filterType}-filterReset`,
      onChange: changeHandlerReplace,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.topFilters.${filterType}.filterReset`
      })
    }, "filterReset"), options.map(item => /*#__PURE__*/_jsx(Checkbox, {
      alignment: "end",
      checked: valuesSet.contains(item),
      "data-test-id": `${filterType}-${item}`,
      onChange: changeHandler,
      value: item,
      children: filterType === 'language' ? LanguageNames[item.toLowerCase()] : /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.topFilters.${filterType}.${item}`
      })
    }, item))]
  });
};
const RouterDropdownFilter = _ref => {
  let {
      filterType
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(View, {
    display: "inline-block",
    children: /*#__PURE__*/_jsx(Dropdown, {
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.topFilters.${filterType}.filterTitle`
      }),
      buttonUse: "transparent",
      "data-test-id": `filter-type-${filterType}`,
      children: /*#__PURE__*/_jsx(RouterChecklistFilter, Object.assign({
        filterType: filterType
      }, props))
    })
  });
};
export const RouterFilterTags = ({
  filterType
}) => {
  const [paramValue, setParam] = useSearchParam(filterType);
  const valueSet = ImmutableSet(paramValue);
  const options = FilterItems[filterType] || [];
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: options.map(item => valueSet.has(item) && /*#__PURE__*/_jsx("div", {
      onClick: () => {
        setParam(valueSet.delete(item).toArray());
        UsageTracker.track('filterInteraction', {
          action: 'filter-deselected',
          value: item,
          key: filterType,
          isTag: true
        });
      },
      children: /*#__PURE__*/_jsxs(Tag, {
        closeable: true,
        "data-test-id": `filter-tag-${filterType}-${item}`,
        inline: true,
        children: [!isMobile && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: `learningCenter.topFilters.${filterType}.filterTitle`
          }), ":", ' ']
        }), filterType === 'language' ? LanguageNames[item.toLowerCase()] : /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.topFilters.${filterType}.${item}`
        })]
      }, `${filterType}-${item}`)
    }, item))
  });
};
export default RouterDropdownFilter;